<template>
  <div ref="chart" class="chart" />
</template>

<script>
  import Anychart from 'anychart';

  const options = {
    'chart': {
      'title': 'График 8 (Грузооборот по культурам)',
      'animation': true,
      'tooltip': { 'displayMode': 'union' },
      'interactivity': { 'hoverMode': 'by-x' },
      'yScale': [
        {
          'stackMode': 'value'
        }
      ],
      'legend': {
        'enabled': true,
        'vAlign': 'bottom',
        'hAlign': 'start',
        'position': 'bottom',
        "positionMode": "outside",
        "padding": {
          "left": 10,
          "top": 10,
          "bottom": 0,
          "right": 10
        }
      },
      'series': [{
        'seriesType': 'column',
        'name': 'Пшеница 4 класс',
        'data': [
          { 'x': 'Агрикалчер Кубань', 'value': 2222 },
          { 'x': 'Зерно-трейд', 'value': 42663 },
          { 'x': 'Агрикалчер Ростов', 'value': 24167 },
        ]
      }, {
        'seriesType': 'column',
        'name': 'Пшеница 5 класс',
        'data': [
          { 'x': 'Агрикалчер Кубань', 'value': 25000 },
          { 'x': 'Зерно-трейд', 'value': 21000 },
          { 'x': 'Агрикалчер Ростов', 'value': null },
        ]
      }, {
        'seriesType': 'column',
        'name': 'Ячмень',
        'data': [
          { 'x': 'Агрикалчер Кубань', 'value': 8000 },
          { 'x': 'Зерно-трейд', 'value': null },
          { 'x': 'Агрикалчер Ростов', 'value': null },
        ]
      }, {
        'seriesType': 'column',
        'name': 'Пшеница 3 класс',
        'data': [
          { 'x': 'Агрикалчер Кубань', 'value': null },
          { 'x': 'Зерно-трейд', 'value': 7000 },
          { 'x': 'Агрикалчер Ростов', 'value': null },
        ]
      }, {
        'seriesType': 'column',
        'name': 'Кукуруза',
        'data': [
          { 'x': 'Агрикалчер Кубань', 'value': null },
          { 'x': 'Зерно-трейд', 'value': null },
          { 'x': 'Агрикалчер Ростов', 'value': null },
        ]
      }],
      'type': 'column'
    }
  };

  export default {
    data() {
      return {
        chart: null,
        options
      }
    },

    mounted() {
      if (!this.chart && this.options) {
        this.init();
      }
    },

    methods: {
      init() {
        if (!this.chart && this.options) {
          let _Anychart = this.Anychart || Anychart;
          this.chart = new _Anychart.fromJson(this.options);
          this.chart.container(this.$refs.chart).draw();
        }
      }
    },

    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
    }
  }
</script>

<style scoped>
  .chart {
    width: 800px;
    height: 600px;
  }
</style>